export default __webpack_public_path__ + "static/media/trending-up.0ca69b67.svg";